import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ScheduleService {
  // Base API URL for schedules
  private baseUrl = '/api/schedules';

  constructor(private http: HttpClient) { }

  /**
   * Fetch paginated schedules
  * @param criteria - Search criteria like offset, limit, sortBy, etc.
   * @returns Observable containing paginated schedule data
  */
  getSchedules(criteria: any): Observable < any > {
    let params = new HttpParams();

    // Add criteria as query parameters to the API request
    for(const key in criteria) {
      if (criteria[key] !== null && criteria[key] !== undefined) {
        params = params.append(key, criteria[key]);
      }
    }

      return this.http.get<any>(this.baseUrl, { params });
  }

  /**
   * Fetch all schedules (no pagination)
   * @returns Observable containing all schedules
   */
  getAllSchedules(): Observable < any > {
    return this.http.get<any>(`${this.baseUrl}/all`);
  }
}


